export default __webpack_public_path__ + "static/media/lp-02-exercise-01.6f9adb5d.jpg";